


  
  

  var faAbstractGenerator = {
    prefix: 'fak',
    iconName: 'abstract-generator',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M405.3 64H106.5C83 64 64 83.2 64 106.7l.2 298.7c0 23.5 19 42.7 42.5 42.7H320l128-128V106.7c0-23.5-19.2-42.7-42.7-42.7zm-256 106.7h213.3v42.7H149.3V170.7zm106.7 128H149.3V256H256v42.7zM298.7 416V298.7H416L298.7 416z'
      
    ]
  };

  

  
  

  var faOverleaf = {
    prefix: 'fak',
    iconName: 'overleaf',
    icon: [
      512,
      512,
      [],
      'e000',
      
      'M344.8 .1c-29 1.6-51.3 4.6-73 9.9C209.7 25.2 171.3 56 160.1 99.4c-1.7 6.7-3 14.9-3.5 23.5l-.4 5.7-5.4 3.6c-7.4 4.9-16.5 11.8-24 18c-51.2 42.8-83.3 99.3-90.5 159.2c-1.2 10-1.6 28.5-.8 38.1c3.4 42.2 20.6 80.2 50 110.6c24.9 25.7 56.6 43.2 91.6 50.5c13.9 2.9 18.1 3.3 36.8 3.3c18.7 0 22.7-.4 36.9-3.3c51.8-10.6 97.2-45.1 122-92.7c17.6-33.8 23.8-72.8 17.7-111.4c-8.5-53.3-41.5-100.6-89.1-127.3c-22.5-12.6-51.8-21.5-76.3-23.1c-9.5-.6-10.7-.3-17.8 4.7c-10 7-19.2 15-31 26.7c-16 16-28.1 31-38.4 47.4c-4.9 7.8-14 25-13.5 25.5c.1 .1 2.6-2.2 5.5-5.2c10.2-10.7 20.4-18.2 33.7-24.7c30.1-14.8 63.4-16.2 93.9-3.9c37.3 14.9 64.8 48.6 71.8 88c6 33.2-2.6 67.3-23.6 93.8c-3.7 4.7-12.8 13.9-17.7 17.9c-23.7 19.4-55.2 29.1-85.3 26.1c-32-3.1-60.8-18.8-81.2-44c-35.6-44.2-42.1-96.5-19.1-154.7c17.4-43.9 50.7-83.8 99.1-118.6c41.5-29.9 93.7-55.5 151.9-74.5c11.7-3.8 36.1-11 40.4-11.8l1.9-.4-2.1 1.3c-1.2 .7-7.7 4.1-14.5 7.6c-59.1 30.5-91.6 48.8-120.6 68.2c-7.2 4.8-19.8 13.6-20.9 14.7c-.5 .5 1.5 1.2 11.8 4.7c28.4 9.4 51.4 12.3 73.6 9.1c25.3-3.6 47-15.4 69-37.5c9.8-9.9 18.4-20.1 35.2-41.9c24.1-31.4 34.9-43.6 48.2-54.6c1-.8 1.7-1.7 1.7-1.9c0-.7-12.6-4.6-22-6.8c-14.6-3.5-34.1-6.4-55.3-8.1c-9.3-.8-46.5-1.4-54.8-1z'
      
    ]
  };

  

  
  

  var faTitleGenerator = {
    prefix: 'fak',
    iconName: 'title-generator',
    icon: [
      512,
      512,
      [],
      'e002',
      
      'M42.7 362.7h426.7v42.7H42.7V362.7zm24.5-86.4l18.1-31.6 18.1 31.6 27.7-16-18.1-31.6h36.3v-32H113.1l18.1-31.4-27.7-16L85.3 180.7 67.2 149.3l-27.7 16 18.1 31.4H21.3v32h36.3L39.5 260.3l27.7 16zm142.9-16l27.7 16L256 244.7l18.1 31.6 27.7-16-18.1-31.6H320v-32h-36.3l18.1-31.4-27.7-16L256 180.7l-18.1-31.4-27.7 16 18.1 31.4H192v32h36.3l-18.1 31.6zm280.5-63.6h-36.3l18.1-31.4-27.7-16-18.1 31.4-18.1-31.4-27.7 16 18.1 31.4H362.7v32h36.3l-18.1 31.6 27.7 16 18.1-31.6 18.1 31.6 27.7-16-18.1-31.6h36.3v-32z'
      
    ]
  };

  

  
  

  var faTransformAi = {
    prefix: 'fak',
    iconName: 'transform-ai',
    icon: [
      512,
      512,
      [],
      'e005',
      
      'M512 298.7h-42.7V256h-42.7v42.7H384v42.7h42.7V384h42.7v-42.7H512zM150.6 190.7l-43.9-20.1 43.9-20.1 20.1-43.9 20.1 43.9 43.9 20.1-43.9 20.1-20.1 43.9zM170.7 448l20.1-43.9L234.7 384l-43.9-20.1L170.7 320l-20.1 43.9L106.7 384l43.9 20.1zM93.2 263.9L64 277.3l29.2 13.4L106.7 320l13.4-29.2 29.2-13.4-29.2-13.4-13.4-29.2zM256 256c0-58.2 23-112.4 58.7-154.7L256 42.7h149.3V192l-60.2-60.2c-28.6 35-46.5 78.9-46.5 124.2c0 70.8 44.8 135.7 106.7 166.8v46.5C318.1 435.4 256 348.8 256 256'
      
    ]
  };

  



export {

  faAbstractGenerator,
  

  faOverleaf,
  

  faTitleGenerator,
  

  faTransformAi,
  

};
